var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefreshIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 10,
    viewBox: "0 0 15 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1549DC",
    d: "M11.803 2.998l2.768 2.078c.203.186.217.503.031.706-.166.181-.434.213-.635.086l-.071-.054-1.57-.995c.018.486-.036.982-.168 1.476-.715 2.668-3.456 4.25-6.124 3.536-.873-.234-1.63-.686-2.23-1.281l.896-.532c.445.388.984.684 1.593.847 2.134.572 4.327-.695 4.9-2.828.141-.53.17-1.063.1-1.574l-1.52 1.48c-.162.186-.43.223-.633.101l-.073-.053c-.185-.161-.223-.429-.1-.632l.052-.073 2.143-2.192c.164-.188.437-.223.64-.096zM8.623.172c.874.234 1.632.686 2.23 1.282l-.895.532c-.446-.39-.985-.685-1.594-.848-2.134-.572-4.327.694-4.9 2.828-.143.537-.17 1.078-.097 1.596l1.507-1.116c.14-.201.403-.266.618-.167l.078.046c.201.141.266.403.166.618l-.045.078-2.227 2.14c-.144.204-.411.268-.628.162l-.078-.047L.203 5.173c-.222-.164-.27-.477-.105-.7.146-.197.41-.256.622-.151l.077.047 1.588 1.389c-.102-.664-.071-1.36.114-2.05C3.214 1.04 5.955-.544 8.623.171z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshIcon);
export default __webpack_public_path__ + "static/media/refresh-icon.146169f214f748f181c01af248e967fe.svg";
export { ForwardRef as ReactComponent };